import React from 'react';
import { Redirect, Route } from "react-router-dom";
import { ProtectedRouteProps } from "./ProtectedRoute";
import { APIFormDef } from "../../../model/User";
import AddDynamicItemForm from "../../../pages/item/AddDynamicItemForm";

export interface ProtectedAddDynamicFormRouteProps extends Omit<ProtectedRouteProps, "component"> {
    formDefinition: APIFormDef;
    formType: "container" | "file" | "tape";
}

export default function ProtectedAddDynamicFormRoute(props: ProtectedAddDynamicFormRouteProps): JSX.Element {
    const { hasPermission, formDefinition, formType, ...rest } = props;
    return (
        <Route {...rest} render={(props) => {
            return hasPermission
                ? <AddDynamicItemForm formDefinition={formDefinition} formType={formType} {...props} />
                : <Redirect to='/login' />
        }} />
    )
}
